<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平台ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入平台ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平台UID">
              <el-input v-model="queryParams.uid" @change="search" placeholder="请输入平台UID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平台名称">
              <el-input v-model="queryParams.name" @change="search" placeholder="请输入平台名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平台性质">
              <el-select v-model="queryParams.is_test" placeholder="请选择平台性质" @change="search" clearable style="width: 100%;">
                <el-option label="测试使用" :value="1"></el-option>
                <el-option label="正式使用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="使用状态">
              <el-select v-model="queryParams.is_use" placeholder="请选择使用状态" @change="search" clearable style="width: 100%;">
                <el-option label="使用中" :value="1"></el-option>
                <el-option label="未使用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <MyTable
        ref="myTableRef"
        :table-data="tableData"
        :columns="columns"
        :loading="loading"

        :total="total"
        :page-no="queryParams.pageNo"
        :page-size="queryParams.pageSize"
        @pagination-change="paginationChange"
      >
        <!-- 平台性质 -->
        <template #is_test={value}>
          <el-tag v-if="value == 1" type="warning" size="small">测试平台</el-tag>
          <el-tag v-if="value == 0" size="small">正式平台</el-tag>
        </template>
        <!-- 使用状态-表头 -->
        <template #header_is_use={column}>
          <el-tooltip class="item" effect="dark" content="同一平台同时只能有一条数据为开启状态, 开启后会自动关闭其他数据" placement="top-start">
            <div>
              <span class="mr5">{{ column.label }}</span>
              <i class="el-icon-warning-outline"></i>
            </div>
          </el-tooltip>
        </template>
        <!-- 使用状态-内容 -->
        <template #is_use={scope,value}>
          <el-switch
            :value="value"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
            @change="changeUse(scope.row)">
          </el-switch>
        </template>
        <template #operation>
          <el-table-column fixed="right" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="medium" class="mr10" @click="handleEdit(scope.row)">编辑</el-button>
              <el-popconfirm
                confirm-button-text='确定'
                cancel-button-text='取消'
                icon="el-icon-info"
                icon-color="red"
                title="确定要删除吗？"
                @confirm="handleDel(scope.row.id)"
              >
                <el-button slot="reference" type="text" class="PUB_BTN_RED">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </MyTable>
      <edit 
        v-if="dialogVisible" 
        :editID="editID"
        :dialogVisible="dialogVisible" 
        @NoneDlog="NoneDlog" 
        @AddOk="AddOk"
      >
      </edit>
    </el-card>
  </div>
</template>

<script>
import {KsNovalManagement} from "@/api/ksNovalManagement";
import {processErrors} from "@/utils/errorHandler";
const api = KsNovalManagement();
export default {
  components: {
    Edit:()=>import('./edit.vue')
  },
  data() {
    return {
      columns:[
        {
          label: 'ID',
          prop: 'id',
          width: '80',
        },
        {
          label: '平台名称',
          prop: 'name',
        },
        {
          label: '平台UID',
          prop: 'uid',
        },
        {
          label: 'AK秘钥',
          prop: 'ak',
        },
        {
          label: 'SK秘钥',
          prop: 'sk',
        },
        {
          label: '平台性质',
          prop: 'is_test',
          slotKey: 'is_test',
        },
        {
          label: '使用状态',
          prop: 'is_use',
          slotKey: 'is_use',
          headerSlotKey: 'header_is_use',
        },
      ],
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:'',
        uid:'',
        is_test: '',
        is_use: '',
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
      },

      tableData: [],
      editID: "",
      // 总条数
      total: 0,
      dialogVisible: false,
      loading: false,
    };
  },
  created() {
    this.getList()
  },
  methods: {

    getList(type) {
      this.loading = true
      if (type != 'changePage') {
        this.queryParams.pageNo = 1
      }
      
      api.ApiPlatformList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },
    paginationChange({pageNo, pageSize}){
      this.queryParams.pageNo = pageNo
      this.queryParams.pageSize = pageSize
      this.getList('changePage')
    },
    search() {
      this.getList()
    },
    changeUse(item){
      let statusText = item.is_use == 1 ? '关闭' : '启用'
      this.$alert( `确定要${statusText}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.ApiPlatformUpdateStatus({
          id: item.id,
          is_use: item.is_use == 1 ? 0 : 1
        }).then(result => {
          if (result.code == 0) {
            this.$message({
              message: statusText + '成功',
              type: 'success'
            });
            this.getList('changePage')
          } else {
            this.$message({
              message: statusText + '失败:' + result.msg,
              type: 'error'
            });
          }
        });
      })
    },
    handleDel(id){
      api.ApiPlatformDel({id}).then(res=>{
        if (res.code == 0) { 
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList('changePage')
        }
      })
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:'',
        uid:'',
        is_test: '',
        is_use: '',
      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.dialogVisible = true
    },
    NoneDlog() {
      this.dialogVisible = false
    },
    AddOk() {
      this.editID = ""
      this.dialogVisible = false
      this.getList()
    },
    handleEdit(row) {
      this.editID = row.id
      this.dialogVisible = true
    },
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

::v-deep .el-radio input[aria-hidden="true"] {
  display: none !important;
}
</style>